/* lp40sub-e1 — E1案で足した挙動だけ
 *
 * 個数×間隔ピッカー本体、レビューカルーセル、スクロール演出、CTA計測は
 * lp40sub-c3.js がそのまま担当する。ここはその上に足すぶんだけを持つ。
 *   1. 1個あたりの価格と「単品購入よりいくらお得か」の同期
 *   2. 地域別のお届け総額（選んだ個数に合わせて送料区分と総額を切り替える）
 *   3. お客様の声を、商品ページへ飛ばさずにこのページで追加表示する
 *   4. カルーセルを指で触れたら自動で切り替わらないようにする
 *   5. 固定CTAをファーストビューを過ぎてから出す
 *
 * c3 側の内部状態には触らない。自動再生の一時停止は、c3 が既に持っている
 * mouseenter / mouseleave の口を使って外から知らせる。
 *
 * 固定CTAの出し入れに requestAnimationFrame のスロットルを使わないこと。
 * 読み込み時にタブが裏にあるとコールバックが来ず、実行中フラグが立ったままになって
 * それ以降のスクロールが全部素通りする。読むのは要素1つの矩形だけなので直接呼ぶ。
 *
 * JSが動かない環境でも、Liquid が既定値（40個・月1回）で正しい金額とhrefを
 * 出力済みなので、価格表示も購入導線もそのまま成立する。
 */
(function () {
  'use strict';
  if (window.__lp40subE1) return;
  window.__lp40subE1 = true;

  var LP_VERSION = 'e1';

  function all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function yen(n) {
    return Number(n).toLocaleString('ja-JP');
  }
  function num(el, attr) {
    return parseInt(el.getAttribute(attr) || '0', 10) || 0;
  }
  function push(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  /* ============ 1・2. 1個あたり／お得額／地域別のお届け総額 ============ */
  function initPrice() {
    var qtyInputs = all('input[name="lp3-qty"]');
    if (!qtyInputs.length) return;

    function checked() {
      for (var i = 0; i < qtyInputs.length; i++) if (qtyInputs[i].checked) return qtyInputs[i];
      return qtyInputs[0];
    }

    function sync() {
      var q = checked();
      if (!q) return;

      var qty = num(q, 'data-qty');
      var price = num(q, 'data-price');
      var once = num(q, 'data-once');
      var size = q.getAttribute('data-size') === '60' ? '60' : '80';
      var save = once > price ? once - price : 0;
      var unit = qty > 0 ? Math.round(price / qty) : 0;

      all('[data-e1-save]').forEach(function (e) { e.textContent = yen(save); });
      all('[data-e1-once]').forEach(function (e) { e.textContent = yen(once); });
      all('[data-e1-unit]').forEach(function (e) { e.textContent = yen(unit); });
      all('[data-e1-qty]').forEach(function (e) { e.textContent = qty + '個'; });

      all('[data-e1-region]').forEach(function (row) {
        var ship = num(row, size === '60' ? 'data-ship60' : 'data-ship80');
        var s = row.querySelector('[data-e1-region-ship]');
        var t = row.querySelector('[data-e1-region-total]');
        if (s) s.textContent = yen(ship) + '円';
        if (t) t.textContent = yen(price + ship) + '円';
      });
    }

    qtyInputs.forEach(function (el) { el.addEventListener('change', sync); });
    sync();
  }

  /* ============ 3. お客様の声を、このページで追加表示する ============ */
  function initMoreReviews() {
    all('[data-e1-more]').forEach(function (btn) {
      var list = document.getElementById(btn.getAttribute('aria-controls') || '');
      if (!list) return;

      btn.addEventListener('click', function () {
        list.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
        push({
          event: 'lp_review_more',
          lp_version: LP_VERSION,
          review_count: all('.lp3-rv', list).length
        });
        var first = list.querySelector('.lp3-rv');
        if (first) {
          first.setAttribute('tabindex', '-1');
          first.focus({ preventScroll: true });
        }
        var wrap = btn.parentNode;
        if (wrap) wrap.removeChild(btn);
      });
    });
  }

  /* ============ 4. 指で触れているあいだは自動で切り替えない ============ */
  function initTouchPause() {
    all('[data-lp3-carousel]').forEach(function (car) {
      var timer = null;

      function pause() {
        // c3 側がホバー中の一時停止として扱ってくれる
        car.dispatchEvent(new MouseEvent('mouseenter'));
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          car.dispatchEvent(new MouseEvent('mouseleave'));
        }, 30000);
      }

      car.addEventListener('touchstart', function (e) {
        // 前後ボタン・ドット・自動再生ボタンは c3 側が面倒を見ている
        if (e.target && e.target.closest && e.target.closest('.lp3-play, .lp3-nav, .lp3-dots')) return;
        pause();
      }, { passive: true });
    });
  }

  /* ============ 5. 固定CTAはファーストビューを過ぎてから ============ */
  function initSticky() {
    var bar = document.querySelector('.lp3-sticky');
    var hero = document.querySelector('.lp3-hero');
    if (!bar || !hero) return;

    bar.classList.add('lp3e-sticky');

    function check() {
      bar.classList.toggle('lp3e-sticky-off', hero.getBoundingClientRect().bottom >= 48);
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    window.addEventListener('load', check);
    check();
  }

  /* ============ 計測 ============ */
  function initTracking() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var soft = e.target.closest('[data-e1-softcta]');
      if (soft) {
        push({
          event: 'lp_soft_cta_click',
          lp_version: LP_VERSION,
          cta_location: soft.getAttribute('data-cta-location') || ''
        });
      }
    });

    all('[data-e1-regions]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        push({
          event: 'lp_region_table_open',
          lp_version: LP_VERSION,
          cta_location: d.getAttribute('data-cta-location') || ''
        });
      });
    });

    push({ event: 'lp_view', lp_version: LP_VERSION });
  }

  function boot() {
    initPrice();
    initMoreReviews();
    initTouchPause();
    initSticky();
    initTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
